/* KIAURA colorway AJAX swap.
   Colorways are separate products, so switching color is a navigation. This
   swaps the main product section in place via the Section Rendering API
   instead of doing a full page load, and rewrites the URL so refresh and
   share still land on the right colorway.

   Symmetry is a web component theme (<product-form>, <buy-buttons>,
   <loader-button>), so replacing section markup re-runs connectedCallback and
   the theme re-initializes itself. We only need to fire the section lifecycle
   events for anything that is not a custom element.

   Pairs with snippets/colorway-nav.liquid. Generalised from tee-colorway-ajax.js;
   the pack branches are all null-guarded so they no-op on lines without packs. */
(function () {
  var NAV = '[data-cw-colorways]';
  var LINK = '[data-colorway-swap]';
  var cache = Object.create(null);
  var inflight = null;

  function nav() { return document.querySelector(NAV); }

  /* A colorway swap must not drop the pack the shopper is building, so the
     pack params ride across to the target URL. */
  function productSection() {
    var n = nav();
    return n ? n.closest('.shopify-section') : null;
  }

  function sectionIdOf(el) {
    if (!el || !el.id) return null;
    return el.id.replace(/^shopify-section-/, '') || null;
  }

  /* Canonical, path-only. The section render does NOT vary by pack/size/colors
     -- those are client state restored after the swap -- so carrying them into
     the key gave prefetch and swap two different keys for the same HTML:

       prefetch  /products/x?sections=id
       swap      /products/x?pack=3&size=M&sections=id

     which meant the warm cache never hit, every swatch click went to the
     network, and the busy state had time to show. Stripping the query makes
     both sides agree and the swap lands in the same task. */
  var KEEP = ['preview_theme_id', '_ab', '_fd', '_sc'];
  function withSections(url, ids) {
    var u = new URL(url, window.location.origin);
    var here = new URLSearchParams(window.location.search);
    var q = new URLSearchParams();
    q.set('sections', ids.join(','));
    /* Theme preview is normally carried by a cookie, but keep the params that
       establish it so an unprimed preview session cannot silently fetch the
       LIVE theme's section into a dev page. */
    KEEP.forEach(function (k) {
      var v = u.searchParams.get(k) || here.get(k);
      if (v) q.set(k, v);
    });
    return u.pathname + '?' + q.toString();
  }

  /* Carry the whole configuration across a colorway swap. Pack comes from the
     SELECTED RADIO, not the URL: the URL is a mirror of state and can lag, and
     reading it meant selecting Single then switching color resurrected the old
     pack from a stale query string. Size and slot colors come from the URL,
     which tee-packs.js keeps current on every render. */
  function carryPackParams(url) {
    try {
      var here = new URLSearchParams(window.location.search);
      var target = new URL(url, window.location.origin);
      target.searchParams.delete('pack');
      target.searchParams.delete('colors');
      target.searchParams.delete('size');
      target.searchParams.delete('variant');

      /* Read the shared state, not the DOM. The radios are about to be thrown
         away by this very swap, and their checked-state is whatever the server
         rendered, so they are the least reliable thing on the page. */
      var st = window.__teeState || {};
      var size = parseInt(st.pack != null ? st.pack : window.__teePackSize, 10) || 1;
      if (size > 1) target.searchParams.set('pack', String(size));

      /* Read memory, not the current query string. Symmetry's variant picker
         may already have wiped these from the URL by the time we get here. */
      var slots = (st.slots || []).slice(0, Math.max(0, size - 1)).join(',').replace(/,+$/, '');
      if (size > 1 && slots.replace(/,/g, '')) target.searchParams.set('colors', slots);

      var sz = st.size || here.get('size');
      if (sz) target.searchParams.set('size', sz);

      /* Keep the theme-preview params on the URL through a colorway swap. The
         preview cookie survives on its own, but a reviewer who copies the URL
         after switching color would otherwise hand out a link that silently
         renders the LIVE theme instead of this one. */
      KEEP.forEach(function (k) {
        var v = here.get(k);
        if (v) target.searchParams.set(k, v);
      });

      return target.pathname + target.search;
    } catch (e) { return url; }
  }



  var sectionCache = Object.create(null);
  var sectionInFlight = Object.create(null);

  function sectionsUrlFor(url, ids) { return withSections(url, ids); }

  function fetchSections(url, ids) {
    var key = sectionsUrlFor(url, ids);
    if (sectionCache[key]) return Promise.resolve(sectionCache[key]);
    if (sectionInFlight[key]) return sectionInFlight[key];
    sectionInFlight[key] = fetch(key, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j) sectionCache[key] = j;
        delete sectionInFlight[key];
        return j;
      })
      .catch(function (e) { delete sectionInFlight[key]; throw e; });
    return sectionInFlight[key];
  }

  /* Selected size must survive a color change, otherwise switching color
     silently drops you back to the first size. */
  function currentSizeValue(root) {
    var sel = root.querySelector('select[name="id"]');
    if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
      return (sel.selectedOptions[0].textContent || '').trim();
    }
    var r = root.querySelector('input[type="radio"]:checked');
    return r ? r.value : null;
  }

  function restoreSize(root, want) {
    if (!want) return;
    var radios = root.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if ((radios[i].value || '').trim() === want && !radios[i].disabled) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }
    var sel = root.querySelector('select[name="id"]');
    if (!sel) return;
    for (var j = 0; j < sel.options.length; j++) {
      if ((sel.options[j].textContent || '').trim() === want && !sel.options[j].disabled) {
        sel.selectedIndex = j;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  /* Accordions must survive a colorway swap without closing. Copying the open
     attribute is not enough: the element is still torn down and rebuilt, so the
     disclosure component re-initialises and the panel collapses.

     Instead patch the NEW content into the LIVE accordion, then move that live
     node into the incoming tree. The element is never destroyed, so open state,
     panel height and animation state all carry over untouched. Same approach
     Three Nails uses. */
  function carryOverOpenState(current, incoming) {
    var cur = current.querySelectorAll('.product-info-accordion');
    var inc = incoming.querySelectorAll('.product-info-accordion');
    var n = Math.min(cur.length, inc.length);
    for (var i = 0; i < n; i++) {
      var curBody = cur[i].querySelector('.disclosure__content');
      var newBody = inc[i].querySelector('.disclosure__content');
      if (curBody && newBody && curBody.innerHTML !== newBody.innerHTML) {
        curBody.innerHTML = newBody.innerHTML;
      }
      inc[i].replaceWith(cur[i]);
    }
  }

  function preserveNodes(current, incoming) {
    incoming.querySelectorAll('[data-preserve]').forEach(function (node, i) {
      var keep = current.querySelectorAll('[data-preserve]')[i];
      if (keep && node.parentNode) node.parentNode.replaceChild(keep, node);
    });
  }

  /* Loox stars: every colorway in a line shares one Loox group, so the incoming
     rating usually has the same score and count. When it does, keep the live,
     already-drawn widget instead of letting Loox redraw it (the stars blink on
     every swap). Only the product id changes, so copy that across. */
  function preserveRatings(current, incoming) {
    try {
      var live = Array.prototype.slice.call(current.querySelectorAll('.loox-rating[data-rating-upgraded]'));
      incoming.querySelectorAll('.loox-rating').forEach(function (node) {
        var key = node.getAttribute('data-loox-block-id');
        var match = null;
        for (var i = 0; i < live.length; i++) {
          var c = live[i];
          if (key ? c.getAttribute('data-loox-block-id') === key : c.getAttribute('data-id') === node.getAttribute('data-id')) { match = c; break; }
        }
        if (!match || !node.parentNode) return;
        if (match.getAttribute('data-rating') !== node.getAttribute('data-rating') ||
            match.getAttribute('data-raters') !== node.getAttribute('data-raters')) return;
        match.setAttribute('data-id', node.getAttribute('data-id'));
        node.parentNode.replaceChild(match, node);
        live.splice(live.indexOf(match), 1);
      });
    } catch (e) {}
  }

  function reinit(sectionEl) {
    var id = sectionIdOf(sectionEl);
    if (!id) return;
    try {
      document.dispatchEvent(new CustomEvent('shopify:section:unload', { detail: { sectionId: id } }));
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: id, sectionEl: sectionEl } }));
    } catch (e) {}
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    // Reviews apps re-scan on their own events.
    try { document.dispatchEvent(new Event('loox:refresh')); } catch (e) {}
  }

  /* Image warming, modelled on ASRV V3: lead photo of every sibling up front,
     the whole gallery of a colour the moment the shopper reaches for its
     swatch. Two rules keep it from crashing iOS Safari:
     - Warm what the page will paint. The incoming <img>'s own sizes + srcset go
       on BEFORE src, so the browser picks the same candidate the swap renders
       and the warm is a cache hit. Its bare src is the width=4000 fallback and
       is never fetched on its own.
     - No decode(). It pins the full bitmap in memory; with every colour of a
       ten-colour line warmed on load that was ~2 GB and the tab got killed.
       onload is all a cache warm needs. */
  var warmed = Object.create(null);
  var WARM_LEAD = 1;        // per sibling, on page load
  var WARM_GALLERY = 8;     // the colour a shopper is reaching for
  var WARM_MAX_SIBLINGS = 12;
  var WARM_CONCURRENCY = 4; // never starve the page's own images

  var queue = [], running = 0;
  function drain() {
    while (running < WARM_CONCURRENCY && queue.length) {
      var job = queue.shift();
      running++;
      job().then(done, done);
    }
  }
  function done() { running--; drain(); }

  function load(spec) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = img.onerror = function () { resolve(); };
      if (spec.sizes) img.sizes = spec.sizes;
      if (spec.srcset) img.srcset = spec.srcset;
      img.src = spec.src;
    });
  }
  /* urgent = the shopper is reaching for this colour: jump the queue. */
  function preload(spec, urgent) {
    if (!spec || !spec.src) return Promise.resolve();
    var key = spec.srcset || spec.src;
    if (warmed[key]) return warmed[key];
    warmed[key] = new Promise(function (resolve) {
      var job = function () { return load(spec).then(resolve); };
      if (urgent) queue.unshift(job); else queue.push(job);
      drain();
    });
    return warmed[key];
  }

  function imagesIn(fragment, max) {
    var out = [], seen = Object.create(null);
    function add(spec) {
      var key = spec.srcset || spec.src;
      if (!spec.src || seen[key]) return;
      seen[key] = true;
      out.push(spec);
    }
    var mapTag = fragment.querySelector('[data-tee-pack-map]');
    if (mapTag) {
      try {
        var m = JSON.parse(mapTag.textContent);
        (m.media || []).forEach(function (x) { if (x && x.src) add({ src: x.src }); });
      } catch (e) {}
    }
    fragment.querySelectorAll('img[src]').forEach(function (i) {
      add({ src: i.src, srcset: i.getAttribute('srcset') || '', sizes: i.getAttribute('sizes') || '' });
    });
    return out.slice(0, max);
  }

  /* Parsed sibling fragments, so a deeper warm doesn't re-parse the HTML. */
  var fragments = Object.create(null);
  function preloadFrom(key, html, max, urgent) {
    var host = fragments[key];
    if (!host) {
      host = document.createElement('div');
      host.innerHTML = html;
      fragments[key] = host;
    }
    return Promise.all(imagesIn(host, max).map(function (s) { return preload(s, urgent); }));
  }

  function apply(section, id, html, url, wantSize) {
    var host = document.createElement('div');
    host.innerHTML = html;
    var incoming = host.querySelector('#shopify-section-' + id)
                || host.querySelector('.shopify-section')
                || host.firstElementChild;
    if (!incoming) { window.location.href = url; return; }

    carryOverOpenState(section, incoming);
    preserveNodes(section, incoming);
    preserveRatings(section, incoming);

    /* Node swap, not innerHTML. innerHTML empties the container first, which is
       the frame where everything jumps and settles back. */
    section.replaceWith(incoming);
    incoming.removeAttribute('aria-busy');

    /* Size restore has to happen once the node is CONNECTED. Doing it on the
       detached tree fires change at components that have not upgraded yet, so
       the theme never sees it and you land back on the first size. */
    restoreSize(incoming, wantSize);

    /* Publish the colorway we just navigated to. tee-packs.js rebuilds the URL
       from state, so without this it would keep rewriting the OLD path back. */
    try {
      var st = (window.__teeState = window.__teeState || {});
      st.path = new URL(url, window.location.origin).pathname;
    } catch (e) {}
    try { window.history.replaceState({ colorway: url }, '', url); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tee:swapped', { detail: { sectionId: id } }));
    reinit(incoming);

    /* Re-warm the new page's siblings so the next swap is instant too. */
    warmAll();
  }

  function swap(url) {
    var section = productSection();
    var id = sectionIdOf(section);
    if (!section || !id) { window.location.href = url; return; }

    var wantSize = currentSizeValue(section);
    var key = sectionsUrlFor(url, [id]);

    /* Warmed: apply in this same task. No promise, no busy state, nothing to
       wait on. This is what makes a hovered swatch feel instant. */
    var cached = sectionCache[key];
    if (cached && cached[id]) { apply(section, id, cached[id], url, wantSize); return; }

    /* Only show a busy state when we genuinely have to go to the network. */
    section.setAttribute('aria-busy', 'true');
    fetchSections(url, [id])
      .then(function (data) {
        if (!data || !data[id]) { window.location.href = url; return; }
        var cur = productSection() || section;
        apply(cur, id, data[id], url, wantSize);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        var cur = productSection();
        if (cur) cur.removeAttribute('aria-busy');
        window.location.href = url;
      });
  }

  /* Warm a sibling colour: section HTML, then images. depth = how many gallery
     images. A cached section still gets the deeper warm on intent, otherwise
     the idle lead-only pass would leave the rest of the gallery cold. */
  function prefetch(url, depth, urgent) {
    var id = sectionIdOf(productSection());
    if (!id) return;
    var key = sectionsUrlFor(url, [id]);
    fetchSections(url, [id])
      .then(function (data) {
        if (!data || !data[id]) return;
        return preloadFrom(key, data[id], depth || WARM_LEAD, urgent);
      })
      .catch(function () {});
  }

  function onIntent(e) {
    var link = e.target.closest && e.target.closest(LINK);
    if (link && link.href) prefetch(link.href, WARM_GALLERY, true);
  }
  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('pointerdown', onIntent, { passive: true });

  /* Every sibling's HTML and lead photo, through the 4-wide queue so the
     current page's own images win. That is all a swap paints first; the rest
     of the gallery warms on intent. */
  function warmAll() {
    Array.prototype.slice.call(document.querySelectorAll(LINK), 0, WARM_MAX_SIBLINGS)
      .forEach(function (l) { if (l.href) prefetch(l.href, WARM_LEAD); });
  }
  /* Warm straight away. There are only a few colorways, so the cost is two
     small section fetches, and waiting for idle meant an early click paid full
     network latency -- the exact case that felt slow. */
  warmAll();
  if ('requestIdleCallback' in window) requestIdleCallback(warmAll, { timeout: 1500 });

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var link = e.target.closest && e.target.closest(LINK);
    if (!link || !link.href) return;
    if (link.target && link.target !== '_self') return;
    e.preventDefault();
    swap(carryPackParams(link.href));
  });
})();


